import React, { useEffect, useState, createElement } from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { CuerpoSeguroPro } from './components/CuerpoSeguroPro';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { ComparisonTable } from './components/ComparisonTable';
import { Footer } from './components/Footer';
import { SocialProofToast } from './components/SocialProofToast';
import { SocialProofBar } from './components/SocialProofBar';
export function App() {
  // 23 hours, 59 mins, 53 secs in seconds = 86393
  const [timeLeft, setTimeLeft] = useState(86393);
  // Meta Pixel
  useEffect(() => {
    const PIXEL_ID = '1904779843432668';
    // Prevent double-init
    if ((window as any).fbq) return;
    const n: any = (window as any).fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!(window as any)._fbq) (window as any)._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    (window as any).fbq('init', PIXEL_ID);
    (window as any).fbq('track', 'PageView');
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-accent selection:text-brand-dark" data-id="element-0" data-mp="35ozexlizgwa">
      <SocialProofToast data-id="element-1" data-mp="3ubztuaw15jen" />
      <Hero data-id="element-2" data-mp="3uevsk1fpcc45" />
      <SocialProofBar data-id="element-3" data-mp="3uf5m1yzyh1el" />
      <Testimonials data-id="element-4" data-mp="d57h17dyqql6" />
      <PainPoints data-id="element-5" data-mp="d3mmhhrnf7nb" />
      <ProductOverview data-id="element-6" data-mp="d45ua5nl4fnm" />
      <Tomos data-id="element-7" data-mp="d2bjhk6123x9" />
      <Bonuses data-id="element-8" data-mp="85l0op2u8u85" />
      <Pricing id="pricing" timeLeft={timeLeft} data-id="element-9" data-mp="851n1kk80rzx" />
      <CuerpoSeguroPro data-id="element-10" data-mp="86cqtkdo1zr1" />
      <ExtendedTestimonials data-id="element-11" data-mp="3gle9ehqxh1en" />
      <Guarantee data-id="element-12" data-mp="3gklbm69y5m8n" />
      <FAQ data-id="element-13" data-mp="3gm66jx06b771" />
      <ComparisonTable data-id="element-14" data-mp="3glwfs77b0w0a" />

      {/* Final Pricing Section - Reusing Pricing component with an ID wrapper for scrolling if needed, but Pricing already has id="pricing".
                          We'll just render it again, but without the id to avoid duplicate IDs in the DOM. */}
      <div className="py-6 md:py-10 bg-brand-dark border-t border-white/5" data-id="element-15" data-mp="3ljphoo1kr3ur">
        <div className="text-center mb-4 px-4" data-id="element-16" data-mp="2xudec4sxhq0d">
          <h2 className="text-2xl md:text-3xl font-display font-black text-white" data-id="element-17" data-mp="2xt24pocsxo1c">
            Llevate Stretching 360 + Cuerpo Seguro Pro™ hoy
          </h2>
        </div>
        <Pricing id="final-pricing" timeLeft={timeLeft} data-id="element-18" data-mp="18czm8goc19lf" />
      </div>

      <Footer data-id="element-19" data-mp="1d4zsequzwyqg" />
    </div>;
}